import CloseIcon from "@/assets/icons/xmark.svg";
import { cx } from "@/utils";
import Clickable from "@components/Clickable";
import Spinner from "@components/Spinner";
import * as Dialog from "@radix-ui/react-dialog";

import styles from "./Modal.module.css";

export type ModalProps = {
  onHide?: () => void;
  show?: boolean;
  children?: React.ReactNode;
  contentLoading?: boolean;
  className?: string;
} & Omit<Dialog.DialogContentProps, "open">;

/**
 * Radix documentation: https://www.radix-ui.com/primitives/docs/components/dialog
 * Modal built using radix, some remains still exist from the bootstrap modal,
 * like the header and content components, along with the onHide and open props.
 * When we have time, we should migrate the bootstrap modal API to radix ( or something fitting ).
 */

const Modal: React.FunctionComponent<ModalProps> = ({
  onHide,
  show,
  className,
  children,
  contentLoading,
  ...rest
}) => {
  return (
    <Dialog.Root
      open={show}
      // todo, use this new api instead of the old bootstrap onHide api
      onOpenChange={(b: boolean) => {
        if (b === false) onHide?.();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} aria-busy={contentLoading}>
          <Dialog.Content className={cx(styles.content, className)} {...rest}>
            {contentLoading ? (
              <div className={styles.loadingWrapper}>
                <div className={styles.spinner}>
                  <Spinner />
                </div>
              </div>
            ) : (
              children
            )}
            {onHide && (
              <Dialog.Close asChild>
                <Clickable className={styles.closeIcon}>
                  {L.REPORTS_WIDGET_DEFAULT_CLOSE_MODAL}
                  <CloseIcon stroke="currentColor" strokeWidth={2} width={18} />
                </Clickable>
              </Dialog.Close>
            )}
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
